import React, { useContext, useCallback, memo, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { FootballContext } from '../../Home/FootballPage';
import { ResultHeader, ResultFooter, sortResults } from '../Common/ResultsBase';
import { toDateFormat } from '../Common/Common';
import { TournImage, FlagTournIcon } from '../Common/MatchBase';
import FootballTitle from '../Common/FootballTitle';
import { getNoName} from './FGSRES'
import { getNumberSuffix } from '../Common/MatchBase';

const filterNGSData = (match, t, i18n) => {
    const nameLanguage = "name_"+i18n.language;
    const hName = match.homeTeam[nameLanguage];
    const aName = match.awayTeam[nameLanguage];
    const foPools = match?.foPools || []
    let poolData = []
    foPools.sort((x,y)=> x.instNo - y.instNo).forEach(foPool => {
        const combinations = foPool?.lines?.[0]?.combinations || [];
        
        let winComb = combinations.filter(item => item.status === 'WIN').sort((a,b) => a.winOrd - b.winOrd)
        winComb = winComb.map(item => getNoName(item, nameLanguage)).filter(item => item !== '');
        // REFUND
        let homeRefund = []
        let awayRefund = []
        let otherRefund
        let refundForAll =foPool?.status.indexOf('REFUND')>=0
        if (!refundForAll) {
            homeRefund = combinations.filter(item => item.status.indexOf('REFUND')>=0 && item?.str?.[0] === '1') || []
            awayRefund = combinations.filter(item => item.status.indexOf('REFUND')>=0 && item?.str?.[0] === '2') || []
            homeRefund = homeRefund.map(item => getNoName(item, nameLanguage)).filter(item => item !== '').sort();
            awayRefund = awayRefund.map(item => getNoName(item, nameLanguage)).filter(item => item !== '').sort();
            otherRefund = combinations.find(item => item.status.indexOf('REFUND')>=0 && item?.str === '000')
        }
        let refundCombs = [...homeRefund, ...awayRefund].sort((x, y)=> x.slice(0,3) -  y.slice(0,3))
        if(otherRefund){refundCombs.push(getNoName(otherRefund, nameLanguage))}

        poolData.push(
            {
                winComb,
                refundForAll,
                refundCombs,
                instNo: foPool.instNo
            }
        )
        
    });

    return {
        eventId: match.frontEndId!=null && match.frontEndId!='' ? match.frontEndId : `${match.matchDayOfWeek} ${match.matchNumber}`,
        matchDate: toDateFormat(match.kickOffTime, true, false),
        tournCode: match.tournament?.code,
        tournName: match.tournament?.[nameLanguage],
        hName,
        aName,
        h2a: <>{hName} <br/> {aName}</>,
        poolData
    }
}

const TableHeader = memo(({ page }) => {
    const {t} = useTranslation()
    const context = useContext(FootballContext);
    
    return (
        <>
            <div className='table-header ngsres-table-header'>
                <div className='ngsres-date'>{t('LB_FB_BY_DATE')}</div>
                <div className='ngsres-id'>{t('LB_FB_EVENT_ID')}</div>
                <div className='ngsres-flag'>
                    <FlagTournIcon />
                </div>
                <div  className='text-align-left ngsres-team'>{t('LB_FB_HOME_TEAM')}<br/>{t('LB_FB_AWAY_TEAM')}</div>
                <div className='ngsres-detail'>
                    <div className='ngsres-results'>{t(`LB_FB_TITLE_${getBetTypebyPage(context.content.page)}`)}</div>
                    <div className='rfd ngsres-rfd'>{t('LB_FB_RFD')}</div>
                </div>
            </div>
        </>
    )

})

const TableRow = memo(({matchData, className}) => {
    const {t, i18n} = useTranslation()
    const {
        eventId,
        matchDate,
        tournCode,
        tournName,
        h2a,
        poolData
    } = filterNGSData(matchData, t, i18n);


    return <div data-testid={`nextScorerResults_${eventId}_${matchDate}_matchInfo`} className={`${className}`}>
        <div data-testid={`nextScorerResults_${eventId}_${matchDate}`} className='ngsres-date'>{matchDate}</div>
        <div data-testid={`nextScorerResults_${eventId}`} className='ngsres-id'>{eventId}</div>
        <div data-testid={`nextScorerResults_${eventId}flag`} className='TournImage ngsres-flag'><TournImage code={tournCode} name={tournName} /></div>
        <div data-testid={`nextScorerResults_${eventId}_team`} className='text-align-left ngsres-team'>{h2a}</div>
        <div className='ngsres-detail'>
            {
                poolData.map((item, index) =>{
                    let {winComb, refundForAll, refundCombs,  instNo } = item
                    let noRefund =  !refundForAll && refundCombs.length == 0
                    let lastClassName = (poolData.length -1) == index ? 'detail-last' : null
                    let ngoal = `${instNo}${i18n.language == 'en' ? getNumberSuffix(instNo) : ''}`;
                    return < div key={instNo} className={lastClassName}>
                        <div data-testid={`nextScorerResults_${eventId}_${matchDate}_nextScorer_${index}`} className='ngsres-results'>
                            <div className='ngsres-title'>{t('LB_FB_TITLE_NGS')} [{t('LB_FB_N_GOAL').replace('{0}', ngoal)}]</div>
                            <div>
                                {winComb.length > 0 ? winComb.join(`\n`) : '-'}
                            </div>
                        </div>
                        <div data-testid={`nextScorerResults_${eventId}_${matchDate}_refund_${index}`} className='ngsres-rfd'>
                            <div className='ngsres-title'>{t('LB_FB_TITLE_NGS')} [{t('LB_FB_N_GOAL').replace('{0}', ngoal)}] - {noRefund ? t('LB_FB_NGS_NORFD') : t('LB_FB_RFD')}</div>
                            {!refundForAll ? <div className='ngsres-rfd-detail-player'>{refundCombs.join('\n') }</div>: <div className='color-red'>{t('LB_FB_REFUND_FOR_ALL')}</div>}
                        </div>
                    </div>
                })
            }
        </div>
        
    </div>
})

const TableHeaderMobile  = memo(({ data })=> {
    const {eventId, matchDate, tournName, hName, aName} = data
    const {t} = useTranslation()

    return <div className='fb-fgsres-table-header-m'>
        <div className='h2a'>
            <span className='h-name'>({t('LB_FB_H_S')}) {hName}</span>
            <span className='vs-container'>
                <span className='vs'>vs</span>
            </span>
            <span className='a-name'>{aName} ({t('LB_FB_A_S')})</span>
        </div>
        <div className='other-information'>
            <span className='event-id'>{eventId}</span>
            <span className='match-date'>{matchDate}</span>
            <span className='tourn-name'>{tournName}</span>
        </div>
    </div>
})


const TableBodyMobile  = memo(({ data })=> {
    const {t, i18n} = useTranslation()
    const context = useContext(FootballContext);
    const { poolData} = data
    return <div className='fb-ngsres-table-body-m'>
         {
                poolData.map((item, index) =>{
                    let {winComb, refundForAll, refundCombs,  instNo } = item
                    let noRefund =  !refundForAll && refundCombs.length == 0
                    let lastClassName = (poolData.length -1) == index ? 'detail-last' : ''
                    let ngoal = `${instNo}${i18n.language == 'en' ? getNumberSuffix(instNo) : ''}`;

                    return < div key={instNo} className={`${lastClassName} ngsres-item-m`}>
                        <div className='ngsres-results-m'>
                            <div>{t('LB_FB_TITLE_NGS')} <span style={{whiteSpace: 'nowrap'}}>[{t('LB_FB_N_GOAL').replace('{0}', ngoal)}]</span></div>
                            <div>
                                {winComb.length > 0 ? winComb.join(`\n`) : '-'}
                            </div>
                        </div>
                        {}
                       <div className='ngsres-rfd-m'>
                            <div></div>
                            <div className='ngsres-rfd-detail-m'>
                                <div className='ngsres-title'>{t('LB_FB_TITLE_NGS')} [{t('LB_FB_N_GOAL').replace('{0}', ngoal)}] -  {noRefund ? t('LB_FB_NGS_NORFD') : t('LB_FB_RFD')}</div>
                                {!refundForAll ? <div className='ngsres-rfd-detail-player'>{refundCombs.join('\n') }</div>: <div className='color-red'>{t('LB_FB_REFUND_FOR_ALL')}</div>}
                            </div>
                        </div>
                    </div>
                })
            }
        {/* <div className='first-scorer'>
            <span className='title'>{t(`LB_FB_TITLE_${getBetTypebyPage(context.content.page)}`)}</span>
            <span className='data white-space-pre'>{firstScorer.length > 0 ? firstScorer.join(`\n`) : '-'}</span>
        </div>
        <div className='home-refund'>
            <span className='title'>{t('LB_FB_RFD')} ({t('LB_FB_HOME')})</span>
            <span className='data white-space-pre'>{
                refundForAll ? <span className='color-red'>{t('LB_FB_REFUND_FOR_ALL')}</span> : homeRefund.join(`\n`)
            }</span>
        </div>
        <div className='away-refund'>
            <span className='title'>{t('LB_FB_RFD')} ({t('LB_FB_AWAY')})</span>
            <span className='data white-space-pre'>{refundForAll ? <span className='color-red'>{t('LB_FB_REFUND_FOR_ALL')}</span> : awayRefund.join(`\n`)}</span>
        </div> */}
    </div>
})

const TableMobile = memo(({matchData})=> {
    const {t, i18n} = useTranslation()
    const data = filterNGSData(matchData, t, i18n);
    return <div className='fb-fgsres-table-m'>
        <TableHeaderMobile data={data} />
        <TableBodyMobile data={data} />
    </div>
})


const NGSRES = memo(() => {
    const { t, i18n } = useTranslation();
    const context = useContext(FootballContext);
    const matches = context.content.matchData.matches.sort(sortResults);
    const page = context.content.page
    const Table = useCallback(({matches}) => {
        const table = matches.map((item, index)=> <TableRow matchData={item} className={index %2 ? 'even' : 'odd'} key={item.frontEndId} /> )
        return (
            <div className='fb-fgsres-table fb-ngsres-table'>
                <TableHeader t={t} page={page}/>
                {table}
            </div>
        )
    }, [])

    const TablesMobile = useCallback(({matches}) => {
        const table = matches.map((item)=> <TableMobile matchData={item} key={item.frontEndId} />)
        return <div className='fb-fgsres-tables-m'>
            {table}
        </div>
    }, [])
    return <>
        <ResultHeader />
        
        {matches.length==0 ? 
            <div className='nopool'>
                <div className='nopoolmsg'>
                    {t('LB_FB_CHPRES_NORESULT')}
                </div>
            </div>
            :
            <>
                <header className='football-fgsres-title-m'>
                    <FootballTitle isPoolDefined={true} />
                </header>
                <section>
                    <div className='fb-fgsres-table-container fb-ngsres-table-container'>
                        <Table  matches={matches}/>
                        <TablesMobile matches={matches}/>
                    </div>
                    <ResultFooter />
                </section>
            </>
        }
    </>

})
export default NGSRES;

const getBetTypebyPage = (page)=>{
    return page?.slice(0,3)
}